import React from "react";

function Building08({ fill, ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={fill ?? ""}
      viewBox="0 0 24 24"
      {...restProps}
    >
      <path
        d="M16.005 5.199c-.166.041-.303.14-.463.337l-.122.151-.012 1.117c-.006.614-.022 1.116-.034 1.116-.013 0-.612-.369-1.332-.819-.721-.45-1.407-.864-1.526-.92a1.31 1.31 0 0 0-1.031 0c-.323.15-7.944 4.924-8.083 5.063-.145.146-.252.476-.218.674.042.238.202.47.407.591l.189.111 7.94.012c5.663.009 7.999 0 8.145-.031.259-.056.506-.26.593-.491.054-.145.071-.609.117-3.165.03-1.647.041-3.055.024-3.128a.834.834 0 0 0-.392-.527l-.187-.11-1.94-.007c-1.067-.004-2.001.008-2.075.026m2.928 3.191c-.013.852-.035 1.615-.048 1.695l-.025.144-.91-.617-.91-.617V6.84H18.957l-.024 1.55m-5.123.516c1.602 1.001 2.576 1.63 3.006 1.941l.156.113H6.904l2.518-1.577c1.385-.868 2.541-1.579 2.568-1.58.028-.002.847.495 1.82 1.103m-7.996 5.091a.864.864 0 0 0-.524.396l-.11.187v3.64l.111.189a.82.82 0 0 0 1.418 0l.111-.189v-3.64l-.111-.189c-.178-.303-.567-.474-.895-.394m4 0a.864.864 0 0 0-.524.396l-.11.187v3.64l.111.189a.82.82 0 0 0 1.418 0l.111-.189v-3.64l-.111-.189c-.178-.303-.567-.474-.895-.394m4 0a.864.864 0 0 0-.524.396l-.11.187v3.64l.111.189a.82.82 0 0 0 1.418 0l.111-.189v-3.64l-.111-.189c-.178-.303-.567-.474-.895-.394m4 0a.864.864 0 0 0-.524.396l-.11.187v3.64l.111.189a.82.82 0 0 0 1.418 0l.111-.189v-3.64l-.111-.189c-.178-.303-.567-.474-.895-.394"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default Building08;
